import { useStore } from "@/store/AppStore";
import { PageHeader } from "@/components/kit";
import { Agenda } from "@/components/Agenda";

export default function MasterAgenda() {
  const { state } = useStore();
  return (
    <div data-testid="master-agenda-page">
      <PageHeader eyebrow="Agenda" title="Minha agenda" subtitle="Seus compromissos de consultoria. Esta agenda é só sua; cada empresa tem a própria agenda." />
      <Agenda ownerKey="master" birthdayCompanyIds={state.companies.map((c) => c.id)} />
    </div>
  );
}
